import { useTranslation } from 'react-i18next';
import { useAppState } from 'context/AppState';
import Calendar from 'assets/icons/calendar_today.svg';
import TopBarPattern from 'assets/icons/topbar_pattern.svg';
import { useBreakpoint } from 'hooks';
import { getCropName, useSkeletonLoader } from '../HeroBanner/heroBannerUtils';
import FieldDetails from '../HeroBanner/FieldDetails';
import {
  HeroBanner0aWrapper,
  HeroBanner0aSection,
  HeroBanner0aTitle,
  HeroBanner0aUserName,
  HeroBanner0aDate,
  HeroBanner0aFieldInfo,
} from './HeroBanner0a.styles';

interface HeroBanner0aProps {
  isRecommendationAPILoading: boolean;
}

const HeroBanner0a = (props: HeroBanner0aProps): JSX.Element => {
  const { isRecommendationAPILoading } = props;
  const { isMobile } = useBreakpoint();
  const [t, i18n] = useTranslation();
  const {
    apiData: {
      recommendation,
      recommendationCropwise,
    },
  } = useAppState();

  const date = recommendationCropwise && new Date(recommendationCropwise.created_on);
  const userName = recommendation?.userContactFromAudit;
  const recommendationCW = recommendationCropwise?.recommendations[0];
  const fieldSummaryArea = recommendationCropwise ? recommendationCropwise.summary_area : '';

  const formattedDate = date?.toLocaleString(i18n.language, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const SkeletonLoader = useSkeletonLoader();
  const cropName = getCropName(recommendationCW, recommendationCropwise, t);

  const totalFields = recommendationCW?.multi_field?.assignments.length ?? 0;

  const loading = isRecommendationAPILoading;
  const companyName = recommendationCropwise?.organization_name;

  return (
    <HeroBanner0aWrapper cropName={recommendationCW?.crop_name.toLowerCase() ?? ''}>
      {loading ? (
        SkeletonLoader
      ) : (
        <HeroBanner0aSection isMobile={isMobile}>
          <div className="hero-banner-first-section">
            <HeroBanner0aTitle>{`${t('CREATED FOR')}:`}</HeroBanner0aTitle>
            <HeroBanner0aUserName data-testid="user-name">
              {companyName || (recommendation && `${userName?.firstName} ${userName?.lastName}`)}
            </HeroBanner0aUserName>
            <HeroBanner0aDate>
              <img src={Calendar} alt="No img found" style={{ marginRight: '8px' }} />
              {`${t('Created')}: `}&nbsp;<b>{formattedDate}</b>
            </HeroBanner0aDate>
          </div>
          {!isMobile && <img src={TopBarPattern} alt="No img found" className="leaflet-image" />}
          {!isMobile && (
            <FieldDetails
              totalFields={totalFields}
              fieldSummaryArea={fieldSummaryArea}
              cropNameLowerCase={recommendationCW?.crop_name.toLowerCase() ?? ''}
              cropName={cropName}
              t={t}
              renderDesktop={(content) => (
                <HeroBanner0aFieldInfo data-testid="rec-field-info">{content}</HeroBanner0aFieldInfo>
              )}
            />
          )}
        </HeroBanner0aSection>
      )}
    </HeroBanner0aWrapper>
  );
};

export default HeroBanner0a;
